var map = {
	"./app.js": 15026,
	"./auxiliary.js": 70265,
	"./digitalBook.js": 73356,
	"./offline.js": 38022,
	"./paperCollect.js": 66609,
	"./params.js": 59271,
	"./pictureBook.js": 62398,
	"./pk.js": 16132,
	"./router.js": 96664,
	"./sentence.js": 42700,
	"./special.js": 15642,
	"./text.js": 51610,
	"./unit.js": 26355,
	"./user.js": 82022,
	"./window.js": 40289,
	"./word.js": 27353,
	"./wordDictation.js": 7944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84870;